import { RepositoryFactory } from '../repositories/PassageApi/RepositoryFactory.js'
import CredentialsService from '../services/CredentialsService.js'

const ResultBinomial = RepositoryFactory.get('resultsBinomial')

class ResultBinomialService {
  static async getResultsBinomial (params) {
    try {
      return await ResultBinomial.getResults(CredentialsService.getCurrentTenantId(), params)
    } catch (error) {
      console.log(error)
    }
  }
}

export default ResultBinomialService
